import { storeToRefs } from "pinia";
import { watch } from "vue";
import { useRoute } from "vue-router";

import ModalService from "shared/modals/ModalService";
import { useUserStore } from "shared/stores/user";

export default function modal(name: string) {
  const route = useRoute();
  const { isLoggedIn } = storeToRefs(useUserStore());

  function close() {
    ModalService.close(name);
  }

  watch(isLoggedIn, () => {
    if (!isLoggedIn.value) {
      ModalService.closeAll();
    }
  });

  watch(
    () => route,
    (newRoute, prevRoute) => {
      // Allow modals to be opened immediately after login
      if (prevRoute?.name === "login") {
        return;
      }

      ModalService.closeAll();
    }
  );

  return { close };
}
